require('./dropdown.tpl.html');
require('./dropdownController');
require('./dropdownMediator');
require('./common/button/dropdownButtonComponent');
require('./common/labelButton/labelButtonComponent');
require('./common/popover/dropdownPopoverDirective');
require('./common/search/dropdownSearchComponent');
require('./common/list/dropdownListComponent');
require('./common/focusManager/focusManagerDirective');
require('./common/keyboardControls/umDropdownKeyboardControls');

const DropdownComponent = {
    templateUrl: '/ui/dropdown/dropdown.tpl.html',
    controller: 'umDropdownController',
    bindings: {
        className: '@',
        required: '<',
        optionList: '<',
        placeholder: '<',
        selectedValue: '<',
        statusText: '<',
        isDisabled: '<',
        onChange: '&',
        onClose: '&'
    }
};

angular.module('umCore')
    .component('umDropdown', DropdownComponent);
